export default Object.freeze({
  Pending: 1,
  Approved: 2,
  Settled: 3,
  Paid: 4,
  Cancelled: 5,
  Reversed: 6,
});
